import {Component, OnDestroy, OnInit} from '@angular/core';
import {FlexSheetService} from "@features/spreadsheet/services/flex-sheet.service";
import {PlatformQueryService} from "@core/services/platform-query.service";
import {PlatformQuery} from "@shared/models/platform-query/platform-query";
import {Api} from "@shared/constants/common-field.constants";
import {takeUntil} from "rxjs/operators";
import {SpreadSheetEvent} from "@features/spreadsheet/models/spread-sheet";
import {Subject} from "rxjs";
import * as report from "report";
import {IPlatformHomeMagicBar} from "@shared/components/platform-tool/platform-tool-magic-bar/models/magic-bar-models";
import { HomeSideBarItem } from '@shared/models/platform-tool-models';

@Component({
    standalone: false,
    selector: 'app-worksheet-details-and-instructions',
  templateUrl: './report-worksheet-details-and-instructions.component.html',
  styleUrl: './report-worksheet-details-and-instructions.component.scss'
})
export class ReportWorksheetDetailsAndInstructionsComponent implements OnInit, OnDestroy, IPlatformHomeMagicBar {
  data: any;
  instructions: any;
  private unsubscribe$ = new Subject<void>();
  homeSideBarItem: HomeSideBarItem;


  constructor(private flexSheetService: FlexSheetService,
              private platformQueryService: PlatformQueryService) {
  }


  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnInit(){
    let worksheetId = this.flexSheetService.getCurrentWorkSheet()?.id;
    const reportType =  this.data.currentPlatformLink?.fieldValues['SelectedReportId'];

    this.flexSheetService.spreadSheetEvent$.pipe(takeUntil(this.unsubscribe$)).subscribe(event => {
      if(event.name === SpreadSheetEvent.WorkSheetChanged){
        console.log('Worksheet Changed');
        worksheetId = event.payload?.id;
        if (reportType && worksheetId) {
          this.fetchData(worksheetId, reportType);
        }
      }
    })
    if (reportType && worksheetId) {
      this.fetchData(worksheetId, reportType);
    }
  }

  private fetchData(worksheetId: string, reportType: string) {
    const worksheetInstructionQuery = new PlatformQuery();
    worksheetInstructionQuery.name = 'GetReportWorksheetDetailsAndInstructionsQuery';
    worksheetInstructionQuery.api = Api.Spreadsheet;
    worksheetInstructionQuery.fieldValues['WorksheetId'] = worksheetId;
    worksheetInstructionQuery.fieldValues['ReportType'] = reportType;

    this.platformQueryService.executeQuery(worksheetInstructionQuery).subscribe(response => {
      if (response && response.fieldValues['Instructions']) {
        this.instructions = response.fieldValues['Instructions']?.join('');
      }
    });
  }
}
